// app/javascript/dashboard/routes/dashboard/settings/bots/bots.routes.js
//
// B.3-v2: apenas a LISTAGEM vive aqui dentro de /settings/bots.
// O builder (flow editor) foi MOVIDO pra routes/dashboard/bots/bots.routes.js
// na rota `bot_flow_editor` (path /app/accounts/:accountId/bots/:botId/flow),
// fora da arvore de /settings/ — pra escapar do SettingsWrapper/max-w e ocupar
// tela inteira igual Kinbox.
import { frontendURL } from '../../../../helper/URLHelper';

const BotsIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bots'),
      name: 'settings_bots_index',
      component: BotsIndex,
      meta: { permissions: ['administrator'] },
    },
  ],
};
